<template>
  <div class="p-2">
  <el-collapse class="bg-white my-4 rounded-[5px] behavioral">
    <el-collapse-item
    >
      <template #title>
        <h2>Behavioral Assessment</h2>
      </template>
      <table class="w-full table-auto border-collapse border border-gray-300">
        <thead class="bg-gray-100">
        <tr>
          <th class="text-left px-4 py-2 border border-gray-300">
            Question
          </th>
          <th
              class="text-left  py-2 border border-gray-300"
          >
            Feedback
          </th>
        </tr>
        </thead>
        <tbody v-if="savedAnswer.length > 0">
        <tr
            v-for="(question, index) in savedAnswer"
            :key="index"
            class="border border-gray-300"
        >
          <td class="px-4 py-2 border border-gray-300 text-sm">
            <p class="whitespace-pre-wrap">{{ question.Question }} </p>

          </td>
          <td>
            {{question.Answer}}
          </td>
        </tr>
        </tbody>
      </table>
    </el-collapse-item>

  </el-collapse>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "behavioralAssessment.vue",
  props:["employeeNumber"],
  data() {
    return {
      questions:[],
      savedAnswer:[],
      ReviewPeriodIds: [],
      answers: {},
      filled:false,
      ratings: [
        { value: 5, label: "Strongly Agree" },
        { value: 4, label: "Agree" },
        { value: 3, label: "Neutral" },
        { value: 2, label: "Disagree" },
        { value: 1, label: "Strongly Disagree" },
      ],
      info:{
        answer:''
      }
    }
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getUserType", 'getUser',]),
  },
  created() {
    this.getStrategicQuestions()
    this.getPerformancePeriods()
  },
  methods: {
    getPerformancePeriods() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.ReviewPeriodIds = response.data.Data;
              this.getBehavioralAssessment()
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
      );
    },
    submitAnswers() {
      const payload = {
        PeriodId: this.ReviewPeriodIds[0].Id,
        Assessments: this.questions.map((question, index) => ({
          QuestionId: question.Id,
          Answer: this.answers[index],
        })),
      };
      const unanswered = payload.Assessments.some((item) => !item.Answer);
      if (unanswered) {
        this.$message.error("Please answer all questions before submitting.");
        return;
      }
      let url = `${this.getOrganization}/performance/behavioral/assessment/${this.$ApiVersion}/create`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
          .post(url, payload, options)
          .then((response) => {
            if (response.data.StatusCode == 200){
              this.$message.success("Feedback submitted successfully!");
              this.resetForm();
            }
          })
          .catch((error) => {
            this.$message.error(
                "Failed to submit feedback. Please try again later."
            );
            console.error(error);
          });
    },
    resetForm() {
      this.answers = [];
    },
    getStrategicQuestions() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/strategic/question/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              console.log(response.data.Data)
              this.questions = response.data.Data;
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;

            this.$notify.error({ title: "Failure", message: error.message });
          }
      );
    },
    getBehavioralAssessment(){
      this.loading = true;
      let url = `${this.getOrganization}/performance/behavioral/assessment/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        params: {
          employeeId:this.employeeNumber,
          periodId:this.ReviewPeriodIds[0].Id
        }
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              if (response.data.Data.length > 0){
                this.savedAnswer = response.data.Data
                this.filled = true
              }
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
      );
    },
  }
}
</script>

<style scoped>

</style>